import { useState } from 'react'
import { EmailInput } from './EmailInput'

export interface BaseEmailCaptureProps {
  onSubmit: (email: string, hasError: boolean) => void
  setIsSuccessful: (value: boolean) => void
  isSuccessful: boolean
  processing: boolean
  title: string
  subtitle: string
}

export function BaseEmailCapture({
  onSubmit,
  isSuccessful,
  setIsSuccessful,
  processing,
  title,
  subtitle,
}: BaseEmailCaptureProps) {
  const [email, setEmail] = useState('')
  const [hasError, setHasError] = useState(false)

  return (
    <div className="wrapper px-4 md:px-0" data-testid="rateForIt">
      <div
        className="bg-blue-dark p-8 md:px-32 md:py-8 mt-4 text-center center-content"
        style={{ borderRadius: '8px' }}
      >
        <div className="mb-8 pt-2">
          <h2
            className="text-white mb-2 font-normal"
            style={{ fontFamily: `'DM Serif Display',Garamond,serif` }}
            data-testid="rate-for-it-header"
          >
            {title}
          </h2>
          <p className="type-body-one text-gray">{subtitle}</p>
        </div>
        <div className="display-flex justify-content-center text-white ">
          <div className="w-full max-w-lg">
            <label className="FormLabel text-left right-addon font-circular-bold mb-1 text-white" htmlFor="textInput">
              Email address
            </label>

            <EmailInput
              {...{ email, setEmail, hasError, setHasError, isSuccessful, setIsSuccessful, processing, onSubmit }}
            />

            <p className="mb-0 text-gray text-left type-body-three mt-5">
              By clicking “Subscribe”, I agree to Bankrate’s{' '}
              <a href="https://www.bankrate.com/privacy/" className="Link text-gray">
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
